import Image from 'next/image';
import ListTile from '@/components/ListTile';
import Link from 'next/link';
import { DISCUSSIONS_PATH } from '@/common/constants/routes';
import CustomAvatar from '@/components/CustomAvatar';
import { color } from 'theme.material';
import { styled } from '@mui/material';
import {
  Content,
  ContentWrapper,
  AuthorContainer,
  AuthorName,
} from './DiscussionTile.styles';

const TileContent = styled(ListTile.Content)`
  background: none;
`;
function DiscussionTile({
  slug,
  author,
  content,
  bgColor,
  className,
}: {
  slug: string;
  content: string;
  author: {
    firstName: string;
    lastName: string;
    image: { alt: string; url: string } | null;
  };
  bgColor?: string;
  className?: string;
}): JSX.Element {
  const discussionPath = `${DISCUSSIONS_PATH}/${slug}`;

  return (
    <Link href={discussionPath}>
      <a>
        <ListTile bgColor={bgColor} className={className}>
          <TileContent>
            <ListTile.IconContainer>
              <Image
                width="32"
                height="32"
                layout="intrinsic"
                src="/images/discussion/idea.svg"
              />
            </ListTile.IconContainer>
            <ContentWrapper>
              <Content>{content}</Content>
              <AuthorContainer>
                <CustomAvatar
                  size={{ desktop: 15, mobile: 8 }}
                  name={author?.firstName}
                  image={author?.image?.url}
                />
                <AuthorName>
                  {author?.firstName} {author?.lastName}
                </AuthorName>
              </AuthorContainer>
            </ContentWrapper>
          </TileContent>
        </ListTile>
      </a>
    </Link>
  );
}

DiscussionTile.defaultProps = {
  bgColor: color.grey[100],
  className: null,
};

export default DiscussionTile;
